module.exports = __webpack_public_path__ + "img/iidako_gutsugutsu.de227f15.jpg";